let tipHtml
export default {
  tip (msg) {
    if (tipHtml !== undefined) {
      return
    }
    tipHtml =
      '<div class="db-tip-wrap"><div class="db-tip">' + msg + '</div></div>'
    let $html = $(tipHtml)
    $('body').append($html)
    setTimeout(function () {
      $html.remove()
      tipHtml = undefined
    }, 4000)
  }
}



// WEBPACK FOOTER //
// ./src/config/Tip.js